export const AFFILIATE = {
  panel: 'affiliate-panel',
  loading: 'affiliate-loading',
  locked: 'affiliate-locked',
  referralLink: 'affiliate-referral-link',
  copyLinkButton: 'affiliate-copy-link-btn',
  totalEarned: 'affiliate-total-earned',
  pendingBalance: 'affiliate-balance-pending',
  availableBalance: 'affiliate-balance-available',
  paidBalance: 'affiliate-balance-paid',
  negativeBalance: 'affiliate-negative-balance',
  minimumNote: 'affiliate-minimum-note',
  withdrawButton: 'affiliate-withdraw-btn',
  withdrawalForm: 'affiliate-withdraw-form',
  holderNameInput: 'affiliate-holder-name-input',
  bankNameInput: 'affiliate-bank-name-input',
  accountNumberInput: 'affiliate-account-number-input',
  consentCheckbox: 'affiliate-consent-checkbox',
  withdrawalSubmitButton: 'affiliate-withdraw-submit-btn',
  withdrawalCancelButton: 'affiliate-withdraw-cancel-btn',
  withdrawalSuccess: 'affiliate-withdraw-success',
  history: 'affiliate-history',
  historyEmpty: 'affiliate-history-empty',
  supportLink: 'affiliate-support-link',
};

export const AFFILIATE_ADMIN = {
  page: 'affiliate-admin-page',
  denied: 'affiliate-admin-denied',
  queue: 'affiliate-admin-queue',
  empty: 'affiliate-admin-empty',
  detail: 'affiliate-admin-detail',
  bankHolder: 'affiliate-admin-bank-holder',
  bankName: 'affiliate-admin-bank-name',
  accountNumber: 'affiliate-admin-account-number',
  referenceInput: 'affiliate-admin-reference-input',
  markPaidButton: 'affiliate-admin-mark-paid-btn',
  rejectReasonInput: 'affiliate-admin-reject-reason-input',
  rejectButton: 'affiliate-admin-reject-btn',
  closeDetailButton: 'affiliate-admin-close-detail-btn',
};

